import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3548c050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emEdicao" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Edição de Variavel", -1))
const _hoisted_3 = {
  key: 0,
  class: "erro"
}
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IdFormularioFactory = _resolveComponent("IdFormularioFactory")!
  const _component_TituloInput = _resolveComponent("TituloInput")!
  const _component_TipoVariavelSelecao = _resolveComponent("TipoVariavelSelecao")!
  const _component_BotoesSalvarCancelar = _resolveComponent("BotoesSalvarCancelar")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_IdFormularioFactory, {
      titulo: (_ctx.titulo as Titulo),
      onGerouId: _ctx.gerouId
    }, null, 8, ["titulo", "onGerouId"]),
    _createVNode(_component_TituloInput, {
      titulo: (_ctx.titulo as Titulo),
      onDigitou: _ctx.digitouTitulo
    }, null, 8, ["titulo", "onDigitou"]),
    _createVNode(_component_TipoVariavelSelecao, { onSelecionou: _ctx.selecionarTipoVariavel }, null, 8, ["onSelecionou"]),
    (_ctx.erro)
      ? (_openBlock(), _createElementBlock("article", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.erro) + " ", 1),
          (_ctx.inconsistencias.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(" Inconsistências: "),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inconsistencias, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("footer", null, [
      _createVNode(_component_BotoesSalvarCancelar, {
        onCancelou: _ctx.cancelar,
        onSalvou: _ctx.salvar
      }, null, 8, ["onCancelou", "onSalvou"])
    ])
  ]))
}